import LotteryNumlotIndexSummaryContainer from "../../components/lottery/containers/LotteryNumlotIndexSummaryContainer";
import LotteryNumlotIndexSummaryTemplate from "../../components/lottery/templates/LotteryNumlotIndexSummaryTemplate";
import PageMeta from "../../components/common/PageMeta";
import { LOTTERY_TYPES } from "../../config/lotteryConfig";
import { formatAmount } from "../../utils/common/format";
import LotteryLocalNav from "../../components/lottery/LotteryLocalNav";

function Loto7() {
  const config = LOTTERY_TYPES["lt7"];
  const title = "ロト7";
  const description = "ロト7の最新当選番号・［ 払戻金 ］情報を掲載。過去の当選結果も検索できます。";
  return (
    <>
      <PageMeta
        title={title}
        description={description}
        path="/loto7"
        breadcrumbs={[
          { name: "TOP", path: "/" },
          { name: "ロト7", path: "/loto7" },
        ]}
      />
      <LotteryLocalNav placement="mainHeader" lotteryKey="lt7" />
      <section className="mx-auto w-auto min-h-screen mb-4">
        <div className="flex justify-between items-center mb-2 border-b border-b-2 border-primary-500 pb-2 ">
          <h1 className="text-2xl font-bold text-primary-500">{title}</h1>
        </div>
        {/* 見出し下に追加 */}
        <div className="mb-8">
          <p className="mb-1 flex flex-wrap gap-2 text-base font-bold text-primary-500">
            <span>{config.catchcopy}</span>
          </p>
          <p className="mb-1 flex flex-wrap gap-2 text-base font-bold text-primary-500">
            <span>
              最高配当{formatAmount(config.maxPrize)}
              {config.maxPrizeCo && (
                <>／キャリーオーバー時最高配当{formatAmount(config.maxPrizeCo)}</>
              )}
            （{config.maxPrizeLabel}）
            </span>
          </p>
          <p className="flex flex-wrap gap-2 text-xs text-gray-800">
            <span>抽選日：{config.drawDay}</span> / 
            <span>購入単価：{formatAmount(config.price)}</span>
          </p>
        </div>
        <LotteryNumlotIndexSummaryContainer 
          lotteryKey="lt7" 
          title="ロト7" 
          lotteryPath="loto7" 
          Template={LotteryNumlotIndexSummaryTemplate} 
          itemsPerPage={100} 
          showMore={true} 
        />
      </section>
      <LotteryLocalNav placement="mainFooter" lotteryKey="lt7" />
    </>
  );
}
export default Loto7;
